import { moduleName } from '@/constants/global/module';
import { CustomRouteRecord } from '@/types/router/router';

const MkaJourneyDetail = () => import('@/views/modules/mka/pages/mka-journey-detail/MkaJourneyDetail.vue');
const MkaJourneyList = () => import('@/views/modules/mka/pages/mka-journey-list/MkaJourneyList.vue');

const meta = {
  moduleName: moduleName.MKA,
  moduleVersion: '1.0.0',
};

const dataConnectRoutes: Array<CustomRouteRecord> = [
  {
    path: '/mka/detail/:campaignId',
    name: 'mkaDetail',
    component: MkaJourneyDetail,
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'mka.mka',
        to: '/mka',
      },
      {
        text: 'mka.detail',
        active: true,
      },
    ],
  },
  {
    path: '/mka',
    name: 'mka',
    component: MkaJourneyList,
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'mka.mka',
        to: '/mka',
      },
    ],
  },
];

export default dataConnectRoutes;
